// components/ProtectedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';

const ProtectedRoute = ({
  isAllowed,
  redirectRoute = '/login',
  LoadingComponent,
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // If isAllowed is a function, call it
        let authStatus;
        if (typeof isAllowed === 'function') {
          authStatus = await isAllowed();
        } else if (typeof isAllowed === 'boolean') {
          authStatus = isAllowed;
        } else {
          // Default check
          const token = localStorage.getItem('token');
          authStatus = !!token;
        }
        setIsAuthenticated(authStatus);
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [isAllowed]);

  if (isAuthenticated === null) {
    return LoadingComponent ? (
      <LoadingComponent />
    ) : (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{ width: '4rem', height: '4rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <h5 className="mt-3 text-primary">Checking authentication...</h5>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectRoute} replace />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
